import { apiClient } from "../../http-config/APIClient";
const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const createCustomer = async (payload) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}customer/create`,
      method: "POST",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const updateCustomer = async (payload, id) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}customer/update/${id}`,
      method: "PUT",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};
export const getQuestionOption = async (key) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}${key}?page=0&limit=10000`,
      method: "GET",
    });
    return res?.results ?? res?.data ?? res;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const createLead = async (payload) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}lead/create`,
      method: "POST",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const createCustomPackage = async (payload) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}package/customer-create-package`,
      method: "POST",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};
export const updateCustomPackage = async (payload, packageId) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}package//customer-update-package/${packageId}`,
      method: "PUT",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};
export const getLeadById = async (id) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}lead/${id}`,
      method: "GET",
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const downloadLeadById = async (id) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}lead/${id}/pdf`,
      method: "GET",
      responseType: "blob",
    });
    return res;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const userInquiry = async (payload) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}/inquiry/`,
      method: "POST",
      data: payload,
      encrypt: false,
      decrypt: false,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const createNewsLatter = async (payload) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}news-letter/subscribe`,
      method: "POST",
      data: payload,
      encrypt: false,
      decrypt: false,
    });
    return res;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const emailOtpVerification = async (payload) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}customer/verify-otp`,
      method: "POST",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const emailResendOtpVerification = async (payload) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}customer/resend-otp`,
      method: "POST",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const usersPerformance = async ({ payload, leadId }) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}lead/custom-status/${leadId}`,
      method: "PATCH",
      data: payload,
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const findQuoteById = async ({ email, quoteID }) => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}lead/customer-list-quote?email=${email}&quoteID=${quoteID}`,
      method: "GET",
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};

export const verifyToken = async () => {
  try {
    const res = await apiClient({
      url: `${BASE_URL}customer/verify-token`,
      method: "GET",
    });
    return res.data;
  } catch (err) {
    throw err.response?.data || { message: "Something went wrong" };
  }
};
export const jobAPI = {
  // Fetch all jobs
  fetchJobs: async (page = 1, limit = 100) => {
    try {
      const response = await fetch(
        `${BASE_URL}job?page=${page}&limit=${limit}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch jobs");
      }

      const result = await response.json();
      return { data: result.data || [], error: null };
    } catch (error) {
      console.error("Error fetching jobs:", error);
      return { data: [], error: error.message };
    }
  },

  // Submit job application
  submitApplication: async (jobId, formData, resumeFile) => {
    try {
      const form = new FormData();

      // Format skills
      const formattedSkills = Array.isArray(formData.skills)
        ? formData.skills
        : formData.skills
            ?.split(",")
            ?.map((skill) => skill.trim())
            ?.filter((skill) => skill !== "");

      // Convert customAnswers object to array format
      const customAnswersArray = Object.keys(formData.customAnswers || {}).map(
        (questionId) => ({
          questionId: questionId,
          answer: formData.customAnswers[questionId],
        })
      );

      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        city: formData.city,
        country: formData.country,
        totalExperienceYears: formData.totalExperienceYears,
        skills: formattedSkills,
        currentCompany: formData.currentCompany,
        currentTitle: formData.currentTitle,
        expectedCTC: formData.expectedCTC,
        currentCTC: formData.currentCTC,
        earliestStartDate: formData.earliestStartDate,
        customAnswers: customAnswersArray,
      };

      form.append("payload", JSON.stringify(payload));

      if (resumeFile) {
        form.append("resume", resumeFile);
      }

      const response = await fetch(`${BASE_URL}job/${jobId}/applications`, {
        method: "POST",
        body: form,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      return { success: true, message: data.message, data };
    } catch (error) {
      console.error("Apply job error:", error);
      return { success: false, message: error.message, data: null };
    }
  },

  fetchJobById: async (id) => {
    try {
      const res = await fetch(`${BASE_URL}job/${id}`);
      if (!res.ok) {
        throw new Error("Failed to fetch job details");
      }
      const result = await res.json();
      return {
        data: result.data || result,
        error: null,
      };
    } catch (err) {
      return {
        data: null,
        error: err.message,
      };
    }
  },
};
